import { SET_TRANSLATION_RESULTS, RESET_TRANSLATION_RESULTS } from './constants';
const INITIAL_STATE = {
    results: null,
    originLang: null,
    secondOriginLang: null,
    originLangs: null,
};
const reducer = (state = INITIAL_STATE, action) => {
    var _a, _b, _c, _d;
    switch (action.type) {
        case SET_TRANSLATION_RESULTS:
            return {
                results: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.results,
                originLang: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.originLang,
                secondOriginLang: (_c = action.payload) === null || _c === void 0 ? void 0 : _c.secondOriginLang,
                originLangs: (_d = action.payload) === null || _d === void 0 ? void 0 : _d.originLangs,
            };
        case RESET_TRANSLATION_RESULTS:
            return INITIAL_STATE;
        default:
            return state;
    }
};
export default reducer;
